import { z } from "zod";
import { REGIONAL_DICTIONARY } from "../constants/regions";
import { VALIDATION_KEYS } from "../constants/validation-keys";

// Lógica de refinamiento internacionalizada reusable
export const validateInternationalId = (
    data: { identificationNumber?: string | null; countryCode?: string },
    ctx: z.RefinementCtx,
  ) => {
    const idNum = data.identificationNumber;
    if (!idNum) return; // Si está vacío, pasa la validación (es opcional)
  
    // Obtener el código de país (por defecto "ES" si viene vacío o no mapeado)
    const countryKey = (data.countryCode || "ES").trim().toUpperCase();
    const config = REGIONAL_DICTIONARY[countryKey] || REGIONAL_DICTIONARY.DEFAULT;
  
    // 1. Validar expresión de formato general/regex
    if (!config.validationRegex.test(idNum)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["identificationNumber"],
        // Pasamos una clave de traducción en el mensaje o un texto descriptivo
        message: `${VALIDATION_KEYS.PATIENT.ID_FORMAT}|${config.countryName}`
      });
      return;
    }
  
    // 2. Validar regla algorítmica específica (ej: la letra del DNI en España)
    if (config.validateFunction && !config.validateFunction(idNum)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["identificationNumber"],
        message: `${VALIDATION_KEYS.PATIENT.ID_FORMAT}|${config.countryName}`
      });
    }
  };